import * as actionTypes from './constants'

const init = {
    customer: {}
}

const customerDetailsReducer = (state = init, action) => {
 
    switch (action.type) {
        case actionTypes.STORE_CUSTOMER_DET:
            return {
                ...state,
                customer: action.data
            }
        default: return state
    }
}

export default  customerDetailsReducer